import { IconUsersGroup } from '@tabler/icons-react'

export const PERMISSION_SETS_STAFF = {
  id: 'Staff',
  description:
    'Grant access to invite, edit, and deactivate staff for their assigned locations.',
  icon: IconUsersGroup,
  sections: [
    {
      title: 'grant location record access',
      permissions: [
        {
          type: 'checkbox',
          label: 'Manage staff invites',
          children: [
            {
              type: 'checkbox',
              label: 'View invite and pending tabs',
            },
            {
              type: 'checkbox',
              label: `Invite staff to access a location's records`,
            },
            {
              type: 'checkbox',
              label: 'Disable and resend staff invites',
            },
          ],
        },
      ],
    },
    {
      title: 'grant location record access',
      permissions: [
        {
          type: 'checkbox',
          label: 'Deactivate staff access',
        },
        {
          type: 'checkbox',
          label: 'Reactivate staff access',
        },
      ],
    },
  ],
}
